export const CLASS_COMMENTS = 'comments';
export const CLASS_COMMENT = 'comment';
